import { isValidTag } from "./vocabulary";

export interface Tag {
  /** The full tag, e.g. "sp-knowledge" or "knowledge-upload". */
  tag: string;
  /** The first level: the surface or page area. */
  area: string;
  /** The last level: the verb, or the destination for navigation. */
  action: string;
  depth: number;
}

/**
 * Builds the tag for a click target (spec D6): the `data-ph-scope` of every
 * ancestor, outermost first, then the closest `data-ph`. Only the DOM is read,
 * so a portal (menu, dialog) has to declare its whole path in one scope
 * (spec D7). An invalid tag is dropped rather than sent half-right.
 */
export function buildTag(target: Element): Tag | null {
  const tagged = target.closest("[data-ph]");
  const element = tagged?.getAttribute("data-ph");
  if (!tagged || !element) return null;

  const scopes: string[] = [];
  for (let el = tagged.parentElement; el; el = el.parentElement) {
    const scope = el.getAttribute("data-ph-scope");
    if (scope) scopes.unshift(scope);
  }

  const tag = [...scopes, element].join("-");
  if (!isValidTag(tag)) {
    if (import.meta.env.DEV) console.warn(`[analytics] invalid tag dropped: "${tag}"`);
    return null;
  }
  const levels = tag.split("-");
  return { tag, area: levels[0], action: levels[levels.length - 1], depth: levels.length };
}
